export const dictionary = {
  firstName: {
    required: 'Please enter your first name'
  },
  lastName: {
    required: 'Please enter your last name'
  }
};



// WEBPACK FOOTER //
// ./src/validation-dictionary.ts